import { render, staticRenderFns } from "./JournalReveivedDataForm.vue?vue&type=template&id=f7487d30&scoped=true&"
import script from "./JournalReveivedDataForm.vue?vue&type=script&lang=js&"
export * from "./JournalReveivedDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7487d30",
  null
  
)

export default component.exports